import { Circle } from 'lucide-react';

interface StatusBarProps {
  voiceConnected?: boolean;
  apiHealthy?: boolean;
}

export default function StatusBar({ voiceConnected, apiHealthy = true }: StatusBarProps) {
  return (
    <footer className="fixed bottom-0 left-[240px] right-0 flex items-center justify-between px-6 py-2 text-xs z-50"
      style={{
        background: 'var(--bg-header)',
        borderTop: '1px solid var(--border-primary)',
        color: 'var(--text-muted)',
      }}>

      <div className="flex items-center gap-4">
        <span className="flex items-center gap-1.5">
          <Circle size={8} fill={apiHealthy ? 'var(--success)' : 'var(--error)'}
            color={apiHealthy ? 'var(--success)' : 'var(--error)'} />
          API {apiHealthy ? 'Connected' : 'Offline'}
        </span>

        {voiceConnected !== undefined && (
          <span className="flex items-center gap-1.5">
            <Circle size={8}
              fill={voiceConnected ? 'var(--netrun-green)' : 'var(--text-muted)'}
              color={voiceConnected ? 'var(--netrun-green)' : 'var(--text-muted)'} />
            Charlotte {voiceConnected ? 'Live' : 'Idle'}
          </span>
        )}
      </div>

      <div className="flex items-center gap-4">
        <span>Gemini 2.5 Flash</span>
        <span style={{ color: 'var(--netrun-green)' }}>KOG v2.0</span>
      </div>
    </footer>
  );
}
